import { orderBy } from 'lodash-es';
import { routes } from '~/constants';
import { associatedCustomersOf, contactFullName } from './ContactsDashboardRow.utils';
export const CONTACTS_COLUMN_NAMES = [
    'contactName',
    'email',
    'phone'
];
export const DEFAULT_CONTACTS_SORT = {
    name: 'contactName',
    direction: 'asc'
};
const sortValueByColumn = {
    contactName: (contact)=>contactFullName(contact).toLowerCase(),
    email: (contact)=>contact.email.toLowerCase(),
    phone: (contact)=>{
        var _contact_phone;
        return (_contact_phone = contact.phone) !== null && _contact_phone !== void 0 ? _contact_phone : '';
    }
};
export const sortContactsByColumn = (contacts, sort)=>{
    const sortValue = sortValueByColumn[sort.name];
    return sortValue == null ? contacts : orderBy(contacts, sortValue, sort.direction);
};
export const toContactsRows = (contacts)=>contacts.map((contact)=>{
        var _contact_phone;
        return {
            id: contact.contactId,
            contactName: contactFullName(contact),
            email: contact.email,
            phone: (_contact_phone = contact.phone) !== null && _contact_phone !== void 0 ? _contact_phone : '',
            associatedClients: associatedCustomersOf(contact).map((customer)=>({
                    label: customer.customerName,
                    to: routes.client(customer.customerId)
                }))
        };
    });
export const contactsColumns = (texts)=>[
        {
            type: 'text',
            name: 'contactName',
            header: texts.columns.contactName(),
            width: {
                initial: 140,
                min: 140
            },
            weight: 'normal',
            sortable: true,
            bi: {
                name: 'shared_contacts_by_name'
            }
        },
        {
            type: 'text',
            name: 'email',
            header: texts.columns.email(),
            width: {
                initial: 160,
                min: 160
            },
            sortable: true,
            bi: {
                name: 'shared_contacts_by_email'
            }
        },
        {
            type: 'text',
            name: 'phone',
            header: texts.columns.phone(),
            width: {
                initial: 140,
                min: 140
            },
            sortable: true,
            bi: {
                name: 'shared_contacts_by_phone'
            }
        },
        {
            type: 'link',
            name: 'associatedClients',
            header: texts.columns.associatedClients(),
            width: {
                initial: 200,
                min: 200
            }
        }
    ];
